import { Icon } from "semantic-ui-react";

import { INTERVENTION_ELEMENT_TYPES } from "models";

type InterventionElementIconProps = {
  elementType: INTERVENTION_ELEMENT_TYPES;
  parentDmsNr?: string;
};

export const InterventionElementIcon = ({ elementType, parentDmsNr }: InterventionElementIconProps) => {
  const iconsArray: JSX.Element[] = [];

  if (parentDmsNr) iconsArray.push(<Icon key="parent_dms_nr" className="arrow right from line" />);

  switch (elementType) {
    case INTERVENTION_ELEMENT_TYPES.Part:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Part} className="gear" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Labor:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Labor} className="user helmet safety" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Text:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Text} className="file" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Discount:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Discount} className="percent" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.SmallPart:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.SmallPart} className="gears" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Fee:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Fee} className="dollar sign" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Rental:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Rental} className="key" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Menu:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Menu} className="bars" />);
      break;

    case INTERVENTION_ELEMENT_TYPES.Task:
      iconsArray.push(<Icon key={INTERVENTION_ELEMENT_TYPES.Task} className="bars progress regular" />);
      break;

    default:
      break;
  }

  return <>{iconsArray}</>;
};
